export const category = "category";
export const feature = "feature";
export const disclaimer = "disclaimer";
export const legend = "legend";
